import {
  createLprDeviceAsync,
  deleteLprDeviceAsync,
  getLprDeviceByIdAsync,
  updateConfigLprDeviceAsync,
  updateLprDeviceAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateLprDeviceAsync = () => useMutation(createLprDeviceAsync);

export const useGetLprDeviceByIdAsync = () =>
  useMutation(getLprDeviceByIdAsync);

export const useUpdateLprDeviceAsync = () => useMutation(updateLprDeviceAsync);

export const useDeleteLprDeviceAsync = () => useMutation(deleteLprDeviceAsync);

export const useUpdateConfigLprDeviceAsync = () =>
  useMutation(updateConfigLprDeviceAsync);
